import { ApiConnector, POST } from "./request.service";

export default (() => {
  const API = ApiConnector("");
  return {
    SendCallback: async (body) =>
      await API(POST, `/soroban-li`, false, false, false, true).call(body),
  };
})();
